import { ActionIcon, ActionIconProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ChevronRight } from 'lucide-react';
import { forwardRef } from 'react';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryPaginationControlsNextProps = ActionIconProps &
	ElementProps<'button', keyof ActionIconProps>;

export const createRegistryPaginationControlsNext = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistryPaginationControlsNext = forwardRef<
		HTMLButtonElement,
		RegistryPaginationControlsNextProps
	>(({ className, children, onClick, ...props }, ref) => {
		const [click, disabled] = useUnit([model.paginationNextClicked, model.$paginationNextDisabled]);

		return (
			<ActionIcon
				ref={ref}
				data-test-id='registry-pagination-controls-next'
				disabled={disabled}
				variant='outline'
				size='sm'
				className={clsx('registry-pagination-controls-next', className)}
				onClick={(event) => {
					click();
					onClick?.(event);
				}}
				{...props}
			>
				{children ?? <ChevronRight />}
			</ActionIcon>
		);
	});

	return RegistryPaginationControlsNext;
};
